import { render } from "./Pay.vue?vue&type=template&id=2d676a48&scoped=true"
import script from "./Pay.vue?vue&type=script&lang=js"
export * from "./Pay.vue?vue&type=script&lang=js"

import "./Pay.vue?vue&type=style&index=0&id=2d676a48&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d676a48"]])

export default __exports__